var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-center" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", {}, [
        _c(
          "div",
          { staticClass: "px-3 pb-1" },
          [
            this.merchants.length > 1 ||
            this.merchants[0]["merchants"].length > 1
              ? _c("div", { staticClass: "row my-3 my-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-12 justify-content-end d-flex flex-row"
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("signup-merchant", {
                        staticClass: "w-100",
                        attrs: {
                          "contact-id": this.contactId,
                          "contact-type": this.contactType,
                          "is-disabled": _vm.isDisabled,
                          "wholesaler-merchant-data": this.merchants
                        },
                        on: {
                          emitUpdateSelectedMerchant: _vm.updateSelectedMerchant
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row my-3 my-md-4 mb-4" }, [
              _c("div", { staticClass: "col-md-6 py-2 py-md-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success btn-block",
                    class: this.visibilityMerchantForm
                      ? "shadow"
                      : "is-not-selected",
                    attrs: { type: "button" },
                    on: { click: _vm.showMerchantForm }
                  },
                  [
                    _c("i", { staticClass: "fal fa-address-card" }),
                    _vm._v(
                      " Neues\n                            Training\n                            für\n                            Kaufleute!\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 py-2 py-md-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger btn-block",
                    class: this.visibilityEmployeeForm
                      ? "shadow"
                      : "is-not-selected",
                    attrs: { type: "button" },
                    on: { click: _vm.showEmployeeForm }
                  },
                  [
                    _c("i", { staticClass: "fas fa-user-friends" }),
                    _vm._v(
                      " Neues\n                            Training für\n                            Mitarbeiter!\n                        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            !this.trainingDataLoaded
              ? _c("loader")
              : _c("div", { staticClass: "my-2 my-md-3" }, [
                  _c(
                    "div",
                    [
                      this.visibilityMerchantForm
                        ? _c("signup-form-builder", {
                            attrs: {
                              "form-options": this.formMerchant,
                              sendingEmail: this.sendingEmail,
                              headline: "Trainings für Kaufleute"
                            },
                            on: { addTrainingData: _vm.addTraining }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      this.visibilityEmployeeForm
                        ? _c("signup-form-builder", {
                            attrs: {
                              "form-options": this.formEmployee,
                              sendingEmail: this.sendingEmail,
                              headline: "Trainings für Mitarbeiter"
                            },
                            on: { addTrainingData: _vm.addTraining }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 mt-md-4 mt-lg-5 overflow-hidden" },
        [
          _c("section-headline", { attrs: { msg: "Trainings" } }),
          _vm._v(" "),
          _c("div", { staticClass: "px-3 py-1" }, [
            _c(
              "div",
              { staticClass: "row mt-3 " },
              [
                _c("signup-list", {
                  attrs: {
                    "filter-trainings-list": _vm.filterMerchantListTrainings
                  },
                  on: { deleteTraining: _vm.deleteTraining },
                  scopedSlots: _vm._u([
                    {
                      key: "headline",
                      fn: function() {
                        return [
                          _c("block-headline", {
                            attrs: {
                              icon: "fa-address-card",
                              text: "Kaufleute"
                            }
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "empty-list-text",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "list-group-item" }, [
                            _vm._v("Keine Trainings für Kaufleute.")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("signup-list", {
                  staticClass: "border-left",
                  attrs: {
                    "filter-trainings-list": _vm.filterEmployeeListTrainings
                  },
                  on: { deleteTraining: _vm.deleteTraining },
                  scopedSlots: _vm._u([
                    {
                      key: "headline",
                      fn: function() {
                        return [
                          _c("block-headline", {
                            attrs: {
                              icon: "fa-user-friends",
                              text: "Mitarbeiter"
                            }
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "empty-list-text",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "list-group-item" }, [
                            _vm._v("Keine Trainings für Mitarbeiter.")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3 mb-3" }, [
              _c(
                "div",
                { staticClass: "col-md-12 d-flex justify-content-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-success d-flex align-items-center justify-content-center",
                      attrs: {
                        disabled:
                          this.listTrainings.length === 0 || this.sendingEmail
                      },
                      on: { click: _vm.submitTrainings }
                    },
                    [
                      !this.sendingEmail
                        ? _c("i", { staticClass: "fas fa-plus mr-1" })
                        : _vm._e(),
                      _vm._v(" "),
                      this.sendingEmail
                        ? _c("i", {
                            staticClass: "fa fa-spinner fa-spin fa-fw mr-1"
                          })
                        : _vm._e(),
                      _vm._v(
                        " Trainings\n                            Buchen\n                        "
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "mr-2 bg-success d-flex justify-content-center align-items-center rounded-lg"
      },
      [
        _c(
          "p",
          {
            staticClass:
              "m-0 text-white d-flex align-items-center py-1 px-3 min-w-100"
          },
          [
            _c("i", { staticClass: "fas fa-map-marker-alt pr-1" }),
            _vm._v(" Standort:")
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }